import log from 'salvo-lite/log'

class ProductPopUp {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this.scrollPosition = window.pageYOffset
        this.scrollPosition = this._DisableBodyScroll(true, this.scrollPosition)
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        const modal = document.querySelector('.product-pop-up')
        const overlay = document.querySelector('.overlay')
        const navbar = document.querySelector('.site-header-wrapper')
        const disable = this._DisableBodyScroll
        disable(false)

        if (modal === null || overlay === null || navbar === null) return

        modal.querySelector('.product-pop-up__close').addEventListener('click', () => {
            overlay.classList.remove('overlay--show')
            modal.classList.remove('product-pop-up--show')
            navbar.classList.remove('site-header-wrapper--position')
            disable(false)
        })

        overlay.addEventListener('click', () => {
            overlay.classList.remove('overlay--show')
            modal.classList.remove('product-pop-up--show')
            navbar.classList.remove('site-header-wrapper--position')
            disable(false)
        })

        this._elem.addEventListener('click', () => {
            modal.classList.add('product-pop-up--show')
            overlay.classList.add('overlay--show')
            navbar.classList.add('site-header-wrapper--position')
            disable(true)
        })
    }

    _DisableBodyScroll (disable, scrollPosition) {
        // Disable Scroll
        if (disable) {
            // HTML & Body class
            document.documentElement.classList.add('prevent-scroll')
            document.body.classList.add('prevent-scroll')

            // iOS Prevent Scrolling
            scrollPosition = window.pageYOffset
            document.body.style.overflow = 'hidden'
            document.body.style.position = 'fixed'
            document.body.style.top = `-${scrollPosition}px`
            document.body.style.width = '100%'
        // Enable scroll
        } else {
            // HTML & Body class
            document.documentElement.classList.remove('prevent-scroll')
            document.body.classList.remove('prevent-scroll')

            // iOS Enable Scrolling
            document.body.style.removeProperty('overflow')
            document.body.style.removeProperty('position')
            document.body.style.removeProperty('top')
            document.body.style.removeProperty('width')
            window.scrollTo(0, scrollPosition)
        }
        // Return scroll position
        return scrollPosition
    }
}

export default ProductPopUp



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ProductPopUp.js